import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum ETransportActionTypes {
  SetRating = 'NEW_REVIEW/TRANSPORT_RATING/SET',
}

export type TSetTransportRating = ITypedReduxAction<ETransportActionTypes.SetRating, number>;

/**
 * Redux action, который записывает в store общий рейтинг транспорта нового отзыва
 * @param rating number
 */
export const setTransportRating: (rating: number) => TSetTransportRating = actionGenerator<
  ETransportActionTypes.SetRating,
  number
>(ETransportActionTypes.SetRating);
